import React from 'react';
import { LazySection } from './LazySection';
export function Dolores() {
  return <LazySection className="bg-cream" data-id="element-113">
      <div className="container-custom" data-id="element-114">
        <div className="text-center" data-id="element-115">
          <span className="eyebrow" data-id="element-116">Si te pasa esto, seguí leyendo</span>
        </div>
        <h2 className="text-[clamp(32px,4.8vw,50px)] text-center mb-4" data-id="element-117">
          Si ya lo intentaste <em data-id="element-118">todo</em> y el{' '}
          <span className="highlight-keyword" data-id="element-119">patrón</span> <em data-id="element-120">sigue ahí</em>…
        </h2>
        <p className="text-center text-ink-soft text-[17px] max-w-[640px] mx-auto mb-[50px]" data-id="element-121">
          Estas son las frases que más se repiten en foros, grupos y
          consultorios. Fijate si alguna suena como tuya.
        </p>

        <div className="flex flex-col gap-3 max-w-[760px] mx-auto mb-[50px]" data-id="element-122">
          {['Siempre elegís al mismo tipo de persona — aunque jures que esta vez va a ser distinto.', 'Cuando estás a punto de ser feliz, algo dentro tuyo lo arruina — y no sabés qué.', 'Cargás una tristeza que no podés explicar con nada que te haya pasado realmente.', 'Llevás años en terapia. Lo entendés intelectualmente. Pero el patrón sigue ahí.', 'Te cuesta recibir — amor, dinero, reconocimiento. Cuando te lo dan, te incomoda.', 'Sabés qué tenés que hacer — pero algo más fuerte que vos te frena. Y eso te desespera.'].map((text, i) => <div key={i} className="bg-white border border-border border-l-[3px] border-l-red-x rounded-xl p-5 md:px-[26px] flex items-start gap-4 transition-all duration-200 hover:translate-x-1 hover:shadow-soft" data-id="element-123">
              <span className="text-red-x text-[20px] font-semibold shrink-0 leading-[1.2]" data-id="element-124">
                ✕
              </span>
              <p className="font-serif italic text-[17px] text-ink leading-[1.45]" data-id="element-125">
                {text.includes('patrón') ? <>
                    Llevás años en terapia. Lo entendés intelectualmente. Pero
                    el <span className="highlight-keyword" data-id="element-126">patrón</span> sigue
                    ahí.
                  </> : text}
              </p>
            </div>)}
        </div>

        <p className="text-center font-serif italic text-[clamp(22px,3.2vw,32px)] text-gold-dark max-w-[720px] mx-auto leading-[1.3]" data-id="element-127">
          No es falta de voluntad.{' '}
          <strong className="not-italic text-ink font-medium bg-gradient-to-b from-transparent from-60% to-gold/30 to-60% px-1" data-id="element-128">
            Es el mapa <span className="highlight-keyword" data-id="element-129">generacional</span>{' '}
            que tu terapia no te dio.
          </strong>
        </p>
      </div>
    </LazySection>;
}